<template>
<v-card min-width="300px" class="rounded-card" outlined>
    <v-card-title class="mb-2 py-1" :class="{teal: EquipActive, grey: !EquipActive}">
        {{equipName}}
        <v-spacer></v-spacer>
        <v-icon v-if="EquipActive">mdi-checkbox-marked-circle</v-icon>
        <v-btn v-else text icon class="mx-3" @click="tryActivate">Activate</v-btn>
    </v-card-title>
    <v-layout>
      <v-flex xs12>
        <v-card-text class="py-1 px-2 subtitle=2" :class="{'primary--text': EquipActive, 'grey--text': !EquipActive}">
          <span>{{$t('Last Sync Time')}}: </span>
          <span class="font-weight-medium mb-3">{{lastSync.toDate() | dateTimeString}}</span>
          <v-btn class="ms-12 my-2" text icon color="blue lighten-2" @click="details = !details">
            <v-icon>{{details ? "mdi-menu-left" : "mdi-menu-down" }}</v-icon>
          </v-btn>

        </v-card-text>
      </v-flex>
    </v-layout>
    <v-layout wrap v-if="details">
      <v-flex xs12 v-for="(value, label) in equip" v-bind:key="label">
        <v-card-text class="py-0 px-1">
          <span style="float: left; min-width: 44%">{{label}}: </span>
          <span class="font-weight-medium">{{value}}</span>
        </v-card-text>
      </v-flex>
    </v-layout>
</v-card>
</template>

<script>
export default {
  name: "EquipmentPanel",
  props: ["equipIndex"],
  data()  {
    return {
      details: false,
    }
  },
  mounted() {
    this.details = this.equipIndex == 0;
  },

  computed: {
    equip() {
      return this.$store.getters.getEquipInfo(this.equipIndex);
    },
    lastSync() {
      return this.$store.getters.getLastSync(this.equipIndex);
    },
    equipName() {
      return this.$store.getters.getEquipmentName(this.equipIndex);
    },
    EquipActive() {
      return this.$store.getters.getEquipmentActive(this.equipIndex);
    }

  },
  methods: {
    edit() {
      this.showDialog=true;
    },
    close() {
      this.showDialog=false;
    },
    tryActivate() {
      this.$root.$confirm(this.$i18n.t('Replace Active Equipment') + "?", this.$i18n.t('by replacing msg'), { color: "orange" }).then((confirm) => {
          if (confirm) {
            this.$store.dispatch("activateEquipment", this.equipIndex);
            this.details = true;
          }
      });
    },
  }
}
</script>

<style>
  .rounded-card {
    border-radius:8px;
  }
  .teal-background {
    background-color: teal;
  }
</style>
